import React, { useState, useRef, useEffect } from 'react';
import { DatePicker, Input, message, Spin, Empty, Icon } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';
import Scrollbars from 'react-custom-scrollbars';
import { getVideoTaskList, getPicTaskList, getAttachTaskList, getPicTimeList, getVideoTimeList, getAttachTimeList } from '../../../../actions/resourceWrap';
import SelectManuscriptPool from '../../../../view/components/manuscriptPool/SelectManuscriptPool';
import RelationTaskDetail from '../../../../view/components/manuscriptPool/RelationTaskDetail';
import UploadPic from '../uploadPic';
import taskSelected from '../../../../view/components/manuscriptPool/img/card2.png';
import taskUnselected from '../../../../view/components/manuscriptPool/img/otherCard.png';
import timeSelected from '../../../../view/components/manuscriptPool/img/list2.png';
import timeUnselected from '../../../../view/components/manuscriptPool/img/otherList.png';
import PictureItem from '../pictureItem';
import './index.scss';
import {takeTask} from "../../../../actions/interview";

const { RangePicker } = DatePicker
const { Search } = Input

const Task = (props) => {

    const [showType, setshowType] = useState('task'); //列表以什么视图展示  task \ time 
    const [taskData, setTaskData] = useState([]);
    const [keyWords, setKeyWords] = useState('');
    const [time, setTime] = useState([]);
    const [current, setCurrent] = useState(1);
    const [total, setTotal] = useState(0);
    const [pageSize, setPageSize] = useState(4);
    const [loading, setLoading] = useState(false);
    const selectManuscriptPool = useRef();
    const relationTaskDetail = useRef();
    const uploadPic = useRef();
    const [text, setText] = useState(''); //分页文字
    const scrollRef = useRef();

    let interviewRole=2;
    if (props.title === '图片池') {
        interviewRole=2;
    } else if (props.title === '视频池') {
        interviewRole=3;
    } else if (props.title === '附件池') {
        interviewRole=4;
    }

    let timeOut;
    useEffect(() => {
        if (time.length === 0 || time.length === 2) {
            search(current);
        }

        return () => {
            clearTimeout(timeOut);
        }
    }, [time, showType])

    const changeshowType = (e) => {
        setKeyWords('');
        setTime([]);
        setCurrent(1);
        setTotal(0);
        setText('');
        // setTaskData([])
        scrollRef.current.scrollToTop();
        let type = e.target.getAttribute('data-type')
        if (showType === 'task') {
            if (type === 'time') {
                setshowType('task-time');
            }
        } else {
            if (type === 'task') {
                setshowType('task');
            }
        }
    }

    const getParams = () => {
        const startDate = time.length === 0 ? '' : moment(time[0]).startOf('day').unix();
        const endDate = time.length === 0 ? '' : moment(time[1]).endOf('day').unix();
        const queryStr = keyWords !== undefined ? keyWords : '';
        return { page: current, pageSize: pageSize, content: queryStr, startTime: startDate, endTime: endDate, interviewRole: interviewRole, }
    }

    const searchPicTaskList = (page) => {
        let listData = [];
        let params = getParams();
        if (page === 1) {   //加载第一页数据 用全局的loading
            setLoading(true);
        }
        getPicTaskList({ ...params, page }, function (res) {
            setLoading(false); //加载第一页数据 用全局的loading
            if (res.code === 0) {
                for (let i = 0; i < res.data.length; i++) {
                    listData.push({ id: res.data[i].id, title: res.data[i].title, fileList: res.data[i].pictureList, status: res.data[i].status })
                }
                page === 1 ? setTaskData(listData) : setTaskData([...taskData, ...listData]) //加载第一页数据 不用连接上次的数据 //分页 要取之前已经存在的数据
                setCurrent(page);
                setText('');
                setTotal(res.count);
            }
        })
    }

    const searchPicTimeList = (page) => {
        let listData = [];
        let params = getParams();
        if (page === 1) {
            setLoading(true);
        }
        getPicTimeList({ ...params, page }, function (res) {
            setLoading(false)
            if (res.code === 0) {
                for (let i = 0; i < res.data.length; i++) {
                    listData.push({ title: res.data[i].time, fileList: res.data[i].pictureFileList, })
                }
                page === 1 ? setTaskData(listData) : setTaskData([...taskData, ...listData])
                setCurrent(page);
                setText('');
                setTotal(res.count);
            }
        })
    }

    const searchVideoTaskList = (page) => {
        let listData = [];
        let params = getParams();
        if (page === 1) {
            setLoading(true);
        }
        getVideoTaskList({ ...params, page }, function (res) {
            setLoading(false)
            if (res.code === 0) {
                for (let i = 0; i < res.data.length; i++) {
                    listData.push({ id: res.data[i].id, title: res.data[i].title, fileList: res.data[i].videoList, status: res.data[i].status })
                }
                page === 1 ? setTaskData(listData) : setTaskData([...taskData, ...listData])
                setCurrent(page);
                setText('');
                setTotal(res.count);
            }
        })
    }

    const searchVideoTimeList = (page) => {
        let listData = [];
        let params = getParams();
        if (page === 1) {
            setLoading(true);
        }
        getVideoTimeList({ ...params, page }, function (res) {
            setLoading(false);
            if (res.code === 0) {
                for (let i = 0; i < res.data.length; i++) {
                    listData.push({ title: res.data[i].time, fileList: res.data[i].videoFileList })
                }
                page === 1 ? setTaskData(listData) : setTaskData([...taskData, ...listData])
                setCurrent(page);
                setText('');
                setTotal(res.count);
            }
        })
    }

    const searchAttachTaskList = (page) => {
        let listData = [];
        let params = getParams();
        if (page === 1) {
            setLoading(true);
        }
        getAttachTaskList({ ...params, page }, function (res) {
            setLoading(false);
            if (res.code === 0) {
                for (let i = 0; i < res.data.length; i++) {
                    listData.push({ id: res.data[i].id, title: res.data[i].title, fileList: res.data[i].otherFileList, status: res.data[i].status })
                }
                page === 1 ? setTaskData(listData) : setTaskData([...taskData, ...listData])
                setCurrent(page);
                setText('');
                setTotal(res.count);
            }
        })

    }

    const searchAttachTimeList = (page) => {
        let listData = [];
        let params = getParams();
        if (page === 1) {
            setLoading(true);
        }
        getAttachTimeList({ ...params, page }, function (res) {
            setLoading(false);
            if (res.code === 0) {
                for (let i = 0; i < res.data.length; i++) {
                    listData.push({ title: res.data[i].time, fileList: res.data[i].otherFileList })
                }
                page === 1 ? setTaskData(listData) : setTaskData([...taskData, ...listData])
                setCurrent(page);
                setText('');
                setTotal(res.count);
            }
        })
    }

    const search = (start) => {
        if (props.title === '图片池') {
            if (showType === "task") {
                searchPicTaskList(start);
            } else {
                searchPicTimeList(start);
            }
        } else if (props.title === '视频池') {
            if (showType === "task") {
                searchVideoTaskList(start);
            } else {
                searchVideoTimeList(start);
            }
        } else if (props.title === '附件池') {
            if (showType === "task") {
                searchAttachTaskList(start);
            } else {
                searchAttachTimeList(start);
            }
        }
    }

    const onScroll = (e) => {
        if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight) {
            let start = current + 1
            timeOut = setTimeout(() => {
                if (total > taskData.length) {
                    //说明还有下一页，需要请求下一页的数据 展示 '加载更多'
                    setText('正在加载中');
                    search(start);
                } else {
                    setText('已加载全部');
                }
            }, 1000)
        }
    }

  


    return (
        <>
            <div className="task-condition">
                <div>
                    <span style={{backgroundColor:props.newSecondSelectColor}} onClick={() => {
                        selectManuscriptPool.current.showTask({ taskTitle: '关联任务', topBtn: true })
                    }}>关联任务上传</span>
                </div>
                <div>
                    <div className="text">创建时间</div>
                    <RangePicker style={{ width: '300px' }} value={time} allowClear onChange={(dates) => setTime(dates)} />

                    {
                        showType === 'task' ? <Search placeholder="请输入搜索内容" style={{ width: '300px' }} value={keyWords} onChange={(e) => setKeyWords(e.target.value)} onSearch={() => { search(1) }} /> : ''
                    }

                    <div className="pic" style={{width:"35px",height:"35px"}}>
                        <img style={{width:"35px",height:"35px",objectFit:"cover",minHeight:"100%"}} src={`${showType === 'task' ? taskSelected : taskUnselected}`} alt="" onClick={changeshowType} data-type="task" />
                    </div>
                    <div className="pic" style={{width:"35px",height:"35px"}}>
                        <img style={{width:"35px",height:"35px",objectFit:"cover",minHeight:"100%"}} src={`${showType === 'task-time' ? timeSelected : timeUnselected}`} alt="" onClick={changeshowType} data-type="time" />
                    </div>
                </div>
            </div>
            <div className="task-content">
                <Scrollbars onScroll={onScroll} ref={scrollRef}>
                    {
                        loading ? <Spin spinning={loading} className="loading" /> : (
                            taskData.length === 0 ? <Empty className="noData" /> :
                                taskData.map((item, index) => (
                                    <PictureItem newSecondSelectColor={props.newSecondSelectColor} itemData={item} showType={showType} title={props.title} key={item.id} search={search} />))
                        )
                    }
                    {
                        text === '' ? '' : (text === '正在加载中' ? <Spin style={{ width: '100%' }} indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />} /> : <span style={{ display: 'block', width: '100%', textAlign: 'center' }}>已加载全部</span>)
                    }
                </Scrollbars>
            </div>
            <SelectManuscriptPool
                newSecondSelectColor={`#7C53C9`}
                ref={selectManuscriptPool}
                interviewRole={interviewRole}
                callBack={(data) => {
                    window.loading.show();
                    takeTask(data.id).then(res=>{
                        window.loading.hide();
                        message.success("任务："+data.title+"已领取");
                        uploadPic.current.showUploadPic(data)
                    });
                }} />
            <RelationTaskDetail ref={relationTaskDetail} />
            <UploadPic refs={uploadPic} selectManuscriptPool={selectManuscriptPool} title={props.title} search={search} />
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        config: state.systemReducer.config
    }
}

export default connect(mapStateToProps)(Task);
